import { render, staticRenderFns } from "./pos-payment-balance-details.vue?vue&type=template&id=a463a612&scoped=true&"
import script from "./pos-payment-balance-details.vue?vue&type=script&lang=ts&"
export * from "./pos-payment-balance-details.vue?vue&type=script&lang=ts&"
import style0 from "./pos-payment-balance-details.vue?vue&type=style&index=0&id=a463a612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a463a612",
  null
  
)

export default component.exports